import ScopeSearchModel from "./ScopeSearchModel";
import { useParams } from "react-router-dom";

export default function ScopeSearchGrid () {

    const { revisionId, equipmentid } = useParams();

    return (
        <ScopeSearchModel.Grid  
        baseFilters={[
            {
            field: "RevisionIds",
            operator: "notContains",
            value: revisionId,
            type: "csv"
        }]}
        onCellDoubleClickOverride={() => {}}
        extraParams = {{ EquipmentId: equipmentid }} />
    );
}